/* eslint-disable jira/filename-case */
export const LEVEL_ONE = '1';
export const LEVEL_TWO = '2';
export const LEVEL_THREE = '3';
export const LEVEL_FOUR = '4';

export type Level = typeof LEVEL_ONE | typeof LEVEL_TWO | typeof LEVEL_THREE | typeof LEVEL_FOUR;
